module.exports = __webpack_public_path__ + "static/media/compare-vehicle-screenshot.1dabca63.png";